// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"932e33287cd51f763aa9","136":"dbc9f8838aefc432c637","137":"8377f398f9f4f55cb378","186":"3e7b39333b5751b4e5b5"}[chunkId] + ".chunk.js";
};